import { render, staticRenderFns } from "./vliveContent.vue?vue&type=template&id=2cc2f3a3&"
import script from "./vliveContent.vue?vue&type=script&lang=js&"
export * from "./vliveContent.vue?vue&type=script&lang=js&"
import style0 from "./vliveContent.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports